module.exports = __webpack_public_path__ + "img/research-1.5582d5a6.jpg";